"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.httpStatusCodes = void 0;
/* eslint-disable no-magic-numbers */
const httpStatusCodes = exports.httpStatusCodes = {
  ok: 200,
  noContent: 204,
  resetContent: 205,
  multipleChoices: 300
};
/* eslint-enable no-magic-numbers */